import { Container, Spacer } from "@nextui-org/react";
import React from "react";
import SubNav, { Item } from "../navigation/subnav";
import { Outlet } from "react-router-dom";

export default function InventoryLayout() {
  const items: Array<Item> = [
    { name: "Overview", href: "/inventory" },
    { name: "Part Library", href: "/inventory/parts" },
    { name: "Stock Locations", href: "/inventory/locations" },
  ]

  return (
    <>
      <SubNav items={items} />
      <Spacer y={1} />
      <Container>
        <Outlet />
      </Container>
    </>
  )
}
